export default "__VITE_ASSET__5e2bc6cf__"